const styles = theme => ({
  radioButtonsFormControl: {
    width: '100%',
    padding: '16px 4px',
    border: '1px solid #ccc',
  },
  radioButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '20%',
    '& p': {
      marginLeft: '40px',
      marginTop: '-10px',
    },
  },
  radioButtonControl: {
    flex: '1',
    margin: '0',
  },
  radioButton: {
    borderRadius: '0',
    padding: '10px',
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
  },

  buttonsContainer: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  asteriskIcon: {
    position: 'relative',
    top: '-6px',
    width: '10px',
    height: '10px',
  },

  buttonsHolder: {
    width: '100%',
    maxWidth: '1470px !important',
  },

  titleHead: {
    color: '#342D3D',
    display: 'block',
    alignItems: 'center',
    padding: '16px 0px',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '18px',
      fontWeight: '600',
      // '& span': {
      //   // color: theme.palette.primary.main,
      // },
    },
    '& $textGray': {
      color: theme.palette.primary.darkGrey,
      fontSize: '14px',
      alignSelf: 'flex-end',
    },
    '& $title1': {
      fontSize: '20px',
      fontWeight: '600',
    },
  },

  '@media (max-width:599px)': {
    buttonsContainer: {
      bottom: '70px',
    },
  },
});

export default styles;
